/**
 * @Name: 个人中心 store
 */
import services from '../../services'
import devConfig from '@/config/index'

import { __replaceDotCom } from '@/utils/tools'
let hostUrl = devConfig.gateway.MsaGatewayAddress
hostUrl = __replaceDotCom(hostUrl, true)

const state = {
    isThirdLogin: false,
    invoiceTypeList: [],
    importExportStatus: [],
    importStatusList: [
        { itemCode: '1', itemName: '全部' },
        { itemCode: '2', itemName: '成功' },
        { itemCode: '3', itemName: '失败' },
        { itemCode: '4', itemName: '处理中' }
    ],
    downloadFileUrl: `${hostUrl}com.huawei.it.mbs.eventsgo:eventsgomedia/eventsgo/media/downloadAttachment`
}
const getters = {
}
const actions = {

    /**
     * 同意隐私收集
     * @param {*} context
     * @param {*} param
     */
    saveUserConcealAct(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.saveUserConcealSer(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 拒绝隐私收集
     * @param {*} context
     * @param {*} param
     */
    updateConcealStatusAct(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.updateConcealStatusSer(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 删除单条导入记录
     * @param {*} context
     * @param {*} param
     */
    deleteImportAct(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.deleteImportSer(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 删除单条导出记录
     * @param {*} context
     * @param {*} param
     */
    deleteExportAct(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.deleteExportSer(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取个人信息数据
     * @param {*} context
     * @param {*} param
     */
    findPersonalUser(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.findPersonalUser(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 更新个人信息数据
     * @param {*} context
     * @param {*} param
     */
    saveOrUpdatePersonalUser(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.saveOrUpdatePersonalUser(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 分页查询查询常用联系人列表
     * @param {*} context
     * @param {*} param
     */
    findContactPageList(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.findContactPageList(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 保存常用联系人
     * @param {*} context
     * @param {*} param
     */
    saveContactInfo(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.saveContactInfo(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 查询常用联系人详情
     * @param {*} context
     * @param {*} param
     */
    findContactDetailById(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.findContactDetailById(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 删除常用联系人
     * @param {*} context
     * @param {*} param
     */
    delContactInfoById(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.delContactInfoById(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 常用地址详情数据
     * @param {*} context
     * @param {*} param
     */
    findFavoriteAddress(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.findFavoriteAddress(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 常用地址列表数据
     * @param {*} context
     * @param {*} param
     */
    findFavoriteAddressPagedList(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.findFavoriteAddressPagedList(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 新增常用地址
     * @param {*} context
     * @param {*} param
     */
    saveOrUpdateFavoriteAddress(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.saveOrUpdateFavoriteAddress(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 删除常用地址
     * @param {*} context
     * @param {*} param
     */
    deleteFavoriteAddress(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.deleteFavoriteAddress(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 常用发票详情数据
     * @param {*} context
     * @param {*} param
     */
    getInvoiceInfo(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.getInvoiceInfo(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 常用发票列表数据
     * @param {*} context
     * @param {*} param
     */
    getInvoiceList(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.getInvoiceList(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 新增常用发票
     * @param {*} context
     * @param {*} param
     */
    addOrUpdateInvoice(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.addOrUpdateInvoice(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 删除发票发票
     * @param {*} context
     * @param {*} param
     */
    deleteInvoice(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.deleteInvoice(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取我的导入数据
     * @param {*} context
     * @param {*} param
     */
    getMyImportListData(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.getMyImportListData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    },

    /**
     * 获取我的导出数据
     * @param {*} context
     * @param {*} param
     */
    getMyExportListData(context, param) {
        return new Promise((resolve, reject) => {
            services.personalCenterSer.getMyExportListData(param).then((res) => {
                resolve(res.data || {})
            })
        })
    }
}
const mutations = {
    setPublicCommonInvoiceType(state, payload) {
        state.invoiceTypeList = payload
    },
    setImportExportStatus(state, payload) {
        state.importExportStatus = payload
    },
    setisThirdLoginMut(state, payload) {
        state.isThirdLogin = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
